import { isEmpty, trim } from 'lodash';

export function isStringEmptyTrimmed(str: string) {
  return isEmpty(trim(str));
}
